import React, {useRef} from "react";
import styles from "./Checkbox.module.scss";
import clsx from "clsx";

export const Checkbox = ({checked, onChange, id, disabled = false}) => {
  const ref = useRef();

  return <div className={clsx(styles.checkbox, disabled ? styles.disabled : null)}>
    <input id={id} ref={ref} type="checkbox" onChange={() => {
      if (disabled) {
        return;
      }

      onChange(!checked);
    }}/>

    <span
      className="material-icons mt-1"
      onMouseDown={() => {
        if (disabled) {
          return;
        }

        ref.current.focus();
      }}
      onClick={() => {
        if (disabled) {
          return;
        }

        ref.current.focus();

        onChange(!checked);
      }}>
      {checked ? "check_box" : "check_box_outline_blank"}
    </span>
  </div>;
};
